import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const OklahomaMap = ({ onZoneClick }) => {
	const [selectedZone, setSelectedZone] = useState(null);

	const handleZoneClick = (zoneId) => {
		setSelectedZone(zoneId);
		if (onZoneClick) {
			onZoneClick(zoneId);
		}
		console.log('Zone Clicked: %s', zoneId);
	};

	return (
		<svg
			id='oklahoma'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 1000 1000'
			className='map'>
			<polygon
				id='OK_ZS'
				points='952.46 479.41 952.46 706.28 940.71 707.5 918.83 696.16 878.32 669.42 872.65 676.71 799.72 678.33 779.47 685.62 759.66 699.4 748.68 699.4 725.99 679.14 713.83 672.66 691.96 672.66 664.41 695.35 657.12 682.38 632.4 679.14 608.5 665.37 596.5 679.14 582.57 679.14 566.37 658.88 563.13 645.11 545.3 645.11 537.2 651.59 517.75 651.59 445.64 629.71 439.16 611.08 427.81 598.11 418.9 608.65 409.99 612.7 359.75 584.34 363.39 455.95 952.46 479.41'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'OK_ZS' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('OK_ZS')}
			/>
			<polygon
				id='OK_ZN'
				points='952.46 479.41 945.16 413.78 928.96 346.53 927.34 265.5 457.39 265.5 284.8 259.83 160.83 257.4 57.93 249.3 53 316.24 367.04 327.49 363.39 455.95 952.46 479.41'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'OK_ZN' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('OK_ZN')}
			/>
			<rect
				x='507.13'
				y='420.95'
				width='156.35'
				height='22.81'
				fill='none'
				className='shape'
			/>
			<path
				d='M521.82,431.16c0,2.61-.96,5.49-2.74,7.27-1.33,1.32-3.08,2.1-5.16,2.1-3.89,0-5.71-2.93-5.71-6.13,0-2.65,1.04-5.59,2.87-7.38,1.29-1.26,3.15-2.04,5.05-2.04,4.05,0,5.69,2.95,5.69,6.17ZM512.44,428.06c-1.45,1.45-2.29,4.1-2.29,6.2,0,2.45,1.09,4.71,4.03,4.71,1.28,0,2.5-.55,3.44-1.5,1.42-1.42,2.24-4.13,2.24-6.22s-.7-4.69-3.99-4.69c-1.34,0-2.52.58-3.44,1.51Z'
				className='shape'
			/>
			<path
				d='M524.62,440.29l3.01-15.86h1.84l-1.9,9.94h.04c.33-.38.73-.79,1.01-1.09l3.81-3.8h2.29l-4.71,4.44,3.23,6.37h-2.04l-2.6-5.33-1.37,1.22-.78,4.11h-1.84Z'
				className='shape'
			/>
			<path d='M536.75,440.29l3.02-15.86h1.85l-3.03,15.86h-1.85Z' className='shape' />
			<path
				d='M550.82,440.29c0-.65.1-1.67.24-2.79h-.05c-1.17,2.24-2.66,3.04-4.18,3.04-1.91,0-3.11-1.52-3.11-3.57,0-3.76,2.77-7.72,7.47-7.72,1.04,0,2.17.18,2.92.41l-1.1,5.63c-.36,1.88-.51,3.81-.46,5.01h-1.73ZM552.02,430.86c-.26-.08-.66-.15-1.29-.15-2.8,0-5.08,2.91-5.09,5.92,0,1.21.42,2.38,1.84,2.38,1.55,0,3.37-2.01,3.91-4.89l.63-3.26Z'
				className='shape'
			/>
			<path
				d='M557.1,440.29l3.01-15.86h1.85l-1.35,6.96h.04c.93-1.31,2.23-2.15,3.86-2.15,1.23,0,2.69.74,2.69,2.89,0,.58-.07,1.28-.18,1.83l-1.2,6.33h-1.85l1.19-6.24c.08-.39.15-.89.15-1.49,0-.99-.48-1.77-1.68-1.77-1.43,0-3.23,1.68-3.68,4.09l-1.01,5.41h-1.85Z'
				className='shape'
			/>
			<path
				d='M581.19,433.73c0,3.34-2.37,6.8-6,6.8-2.71,0-4.22-2.01-4.22-4.44,0-3.57,2.48-6.86,5.99-6.86,2.91,0,4.23,2.2,4.23,4.49ZM572.88,436.02c0,1.76.98,3.04,2.56,3.04,2.18,0,3.83-2.83,3.83-5.34,0-1.26-.58-3.02-2.52-3.02-2.33,0-3.88,2.84-3.88,5.32Z'
				className='shape'
			/>
			<path
				d='M584.27,440.29l1.43-7.66c.23-1.2.38-2.25.5-3.14h1.63l-.29,2.03h.05c1.01-1.51,2.37-2.27,3.81-2.27,1.64,0,2.44,1.04,2.52,2.41.97-1.56,2.34-2.39,3.97-2.41,1.25,0,2.62.8,2.62,2.83,0,.5-.07,1.23-.18,1.84l-1.21,6.38h-1.81l1.17-6.22c.08-.42.16-.96.16-1.41,0-1.14-.43-1.88-1.63-1.88-1.35,0-2.95,1.55-3.39,3.97l-1.03,5.54h-1.8l1.21-6.34c.09-.48.15-.9.15-1.32,0-.91-.25-1.85-1.62-1.85s-3.04,1.79-3.45,4.08l-1,5.43h-1.81Z'
				className='shape'
			/>
			<path
				d='M611.28,440.29c0-.65.1-1.67.24-2.79h-.05c-1.17,2.24-2.66,3.04-4.18,3.04-1.91,0-3.11-1.52-3.11-3.57,0-3.76,2.77-7.72,7.47-7.72,1.04,0,2.17.18,2.92.41l-1.1,5.63c-.36,1.88-.51,3.81-.46,5.01h-1.73ZM612.48,430.86c-.26-.08-.66-.15-1.29-.15-2.8,0-5.08,2.91-5.09,5.92,0,1.21.42,2.38,1.84,2.38,1.55,0,3.37-2.01,3.91-4.89l.63-3.26Z'
				className='shape'
			/>
			<path
				d='M633.89,439.8c-.85.38-2.22.72-3.91.72-3.79,0-6.11-2.41-6.11-6.25,0-2.83,1.15-5.54,3.22-7.26,1.56-1.32,3.47-2.02,5.67-2.02,1.67,0,2.88.42,3.26.72l-.6,1.5c-.56-.34-1.62-.62-2.96-.62-1.57,0-3.15.61-4.31,1.69-1.42,1.32-2.31,3.45-2.31,5.73,0,2.69,1.24,4.92,4.58,4.92,1.13,0,2.38-.23,3.22-.64l.25,1.51Z'
				className='shape'
			/>
			<path
				d='M637.59,440.29l2.06-10.8h1.85l-2.06,10.8h-1.85ZM639.99,426.46c0-.71.55-1.25,1.22-1.25s1.1.49,1.1,1.16c-.02.73-.54,1.25-1.26,1.25-.65,0-1.08-.5-1.07-1.16Z'
				className='shape'
			/>
			<path
				d='M649.33,426.58l-.56,2.9h2.58l-.29,1.45h-2.58l-.99,5.25c-.12.6-.21,1.16-.21,1.72,0,.65.31,1.05,1.02,1.05.33,0,.63-.02.87-.09l-.09,1.46c-.33.13-.89.2-1.43.2-1.63,0-2.27-.99-2.27-2.1,0-.63.08-1.25.24-2.03l1.05-5.47h-1.55l.28-1.45h1.55l.46-2.43,1.92-.47Z'
				className='shape'
			/>
			<path
				d='M655.88,429.48l1.07,5.81c.24,1.24.38,2.04.49,2.85h.06c.28-.69.6-1.45,1.15-2.65l2.77-6.01h1.97l-4.06,8.21c-1.16,2.34-2.25,4.24-3.72,5.68-1.21,1.22-2.53,1.73-3.14,1.87l-.45-1.59c.46-.16,1.25-.46,1.98-1.04.73-.56,1.51-1.44,2.09-2.49.09-.18.09-.3.05-.49l-2.17-10.15h1.93Z'
				className='shape'
			/>
			<polygon
				points='673.06 441.55 673.23 448.5 680.54 448.5 673.34 452.79 673.51 459.74 668.89 455.45 661.69 459.74 666.03 452.79 661.41 448.5 668.72 448.5 673.06 441.55'
				className='shape'
			/>
			<rect x='796.28' y='380.95' width='57.7' height='22.81' fill='none' className='shape' />
			<path
				d='M802.13,386.84h-4.4l.32-1.61h10.66l-.31,1.61h-4.42l-2.55,13.45h-1.85l2.55-13.45Z'
				className='shape'
			/>
			<path
				d='M818.56,389.48l-1.46,7.66c-.23,1.2-.38,2.25-.48,3.14h-1.67l.28-2.04h-.04c-.96,1.41-2.38,2.29-3.81,2.29s-2.85-.67-2.85-3.13c0-.52.07-1.1.21-1.82l1.17-6.1h1.85l-1.15,6.02c-.11.6-.18,1.12-.18,1.58,0,1.12.46,1.88,1.73,1.88,1.35,0,3.07-1.58,3.52-3.95l1.05-5.54h1.85Z'
				className='shape'
			/>
			<path d='M821.56,400.29l3.02-15.86h1.85l-3.03,15.86h-1.85Z' className='shape' />
			<path
				d='M828.55,398.41c.51.3,1.43.67,2.32.67,1.25,0,2.06-.81,2.06-1.76,0-.84-.38-1.37-1.5-1.99-1.25-.69-1.95-1.65-1.95-2.75,0-1.89,1.64-3.33,3.92-3.33.98,0,1.84.26,2.25.54l-.52,1.4c-.37-.22-1.06-.49-1.86-.49-1.13,0-1.93.7-1.93,1.62,0,.8.52,1.28,1.48,1.82,1.2.68,2.02,1.62,2.02,2.84,0,2.27-1.85,3.56-4.13,3.56-1.16,0-2.2-.37-2.69-.74l.53-1.37Z'
				className='shape'
			/>
			<path
				d='M845.75,400.29c0-.65.1-1.67.24-2.79h-.05c-1.17,2.24-2.66,3.04-4.18,3.04-1.91,0-3.11-1.52-3.11-3.57,0-3.76,2.77-7.72,7.47-7.72,1.04,0,2.17.18,2.92.41l-1.1,5.63c-.36,1.88-.51,3.81-.46,5.01h-1.73ZM846.95,390.86c-.26-.08-.66-.15-1.29-.15-2.8,0-5.08,2.91-5.09,5.92,0,1.21.42,2.38,1.84,2.38,1.55,0,3.37-2.01,3.91-4.89l.63-3.26Z'
				className='shape'
			/>
			<polygon
				points='792.2 366.55 792.38 373.5 799.68 373.5 792.48 377.79 792.66 384.74 788.04 380.45 780.84 384.74 785.18 377.79 780.56 373.5 787.86 373.5 792.2 366.55'
				className='shape'
			/>
			<rect
				x='450.42'
				y='569.95'
				width='78.38'
				height='22.81'
				fill='none'
				className='shape'
			/>
			<path
				d='M453.98,574.23h1.85l-2.57,13.45h6.07l-.31,1.61h-7.91l2.86-15.06Z'
				className='shape'
			/>
			<path
				d='M469.81,589.29c0-.65.1-1.67.24-2.79h-.05c-1.17,2.24-2.66,3.04-4.18,3.04-1.91,0-3.11-1.52-3.11-3.57,0-3.76,2.77-7.72,7.47-7.72,1.04,0,2.17.18,2.92.41l-1.1,5.63c-.36,1.88-.51,3.81-.46,5.01h-1.73ZM471.01,579.86c-.26-.08-.66-.15-1.29-.15-2.8,0-5.08,2.91-5.09,5.92,0,1.21.42,2.38,1.84,2.38,1.55,0,3.37-2.01,3.91-4.89l.63-3.26Z'
				className='shape'
			/>
			<path
				d='M478.64,578.48l.38,6.08c.08,1.34.08,2.03.05,2.91h.05c.26-.71.65-1.63,1.19-2.71l3.21-6.27h1.61l.68,6.16c.11,1.19.18,2.11.17,2.83h.05c.29-.87.58-1.71,1.02-2.74l2.92-6.24h1.89l-5.34,10.8h-1.72l-.71-5.87c-.11-1-.17-1.92-.16-2.88h-.05c-.45,1.04-.76,1.86-1.25,2.82l-3.1,5.92h-1.73l-1-10.8h1.83Z'
				className='shape'
			/>
			<path
				d='M498.52,575.58l-.56,2.9h2.58l-.29,1.45h-2.58l-.99,5.25c-.12.6-.21,1.16-.21,1.72,0,.65.31,1.05,1.02,1.05.33,0,.63-.02.87-.09l-.09,1.46c-.33.13-.89.2-1.43.2-1.63,0-2.27-.99-2.27-2.1,0-.63.08-1.25.24-2.03l1.05-5.47h-1.55l.28-1.45h1.55l.46-2.43,1.92-.47Z'
				className='shape'
			/>
			<path
				d='M512.74,582.73c0,3.34-2.37,6.8-6,6.8-2.71,0-4.22-2.01-4.22-4.44,0-3.57,2.48-6.86,5.99-6.86,2.91,0,4.23,2.2,4.23,4.49ZM504.44,585.02c0,1.76.98,3.04,2.56,3.04,2.18,0,3.83-2.83,3.83-5.34,0-1.26-.58-3.02-2.52-3.02-2.33,0-3.88,2.84-3.88,5.32Z'
				className='shape'
			/>
			<path
				d='M515.83,589.29l1.44-7.66c.24-1.2.39-2.25.51-3.14h1.66l-.28,2.12h.04c.97-1.52,2.43-2.37,4.01-2.37,1.28,0,2.73.74,2.73,3,0,.48-.09,1.17-.19,1.74l-1.2,6.31h-1.85l1.18-6.24c.07-.42.15-.92.15-1.38,0-1.08-.42-1.88-1.69-1.88s-3.2,1.58-3.69,4.25l-.97,5.25h-1.85Z'
				className='shape'
			/>
			<polygon
				points='538.34 589.55 538.52 596.5 545.82 596.5 538.62 600.79 538.79 607.74 534.17 603.45 526.98 607.74 531.32 600.79 526.7 596.5 534 596.5 538.34 589.55'
				className='shape'
			/>
			<rect
				x='686.01'
				y='619.95'
				width='92.99'
				height='22.81'
				fill='none'
				className='shape'
			/>
			<path
				d='M689.76,634.52l-2.39,4.76h-1.95l7.78-15.06h2.19l2.08,15.06h-1.9l-.61-4.76h-5.2ZM694.82,633.05l-.59-4.35c-.08-.79-.19-1.89-.27-2.77h-.05c-.4.9-.78,1.84-1.23,2.74l-2.25,4.38h4.38Z'
				className='shape'
			/>
			<path
				d='M701.28,639.29l1.32-6.96c.27-1.41.43-2.84.55-3.84h1.63c-.09.75-.18,1.51-.3,2.35h.06c.71-1.48,1.86-2.59,3.31-2.59.17,0,.39.01.53.04l-.36,1.83c-.13-.03-.29-.04-.5-.04-1.6,0-3.03,1.94-3.5,4.45l-.89,4.77h-1.85Z'
				className='shape'
			/>
			<path
				d='M721.53,623.42l-2.37,12.44c-.21,1.12-.39,2.38-.46,3.42h-1.7l.29-2.14h-.04c-.99,1.53-2.34,2.38-3.9,2.38-2.08,0-3.23-1.71-3.23-3.93,0-3.84,2.85-7.36,6.68-7.36.68,0,1.44.15,1.91.37l.97-5.18h1.84ZM718.42,630.17c-.37-.25-.99-.46-1.77-.46-2.59,0-4.61,2.76-4.61,5.63,0,1.31.45,2.67,2.04,2.67,1.42,0,3.15-1.63,3.61-4.06l.72-3.78Z'
				className='shape'
			/>
			<path
				d='M723.56,639.29l1.43-7.66c.23-1.2.38-2.25.5-3.14h1.63l-.29,2.03h.05c1.01-1.51,2.37-2.27,3.81-2.27,1.64,0,2.44,1.04,2.52,2.41.97-1.56,2.34-2.39,3.97-2.41,1.25,0,2.62.8,2.62,2.83,0,.5-.07,1.23-.18,1.84l-1.21,6.38h-1.81l1.17-6.22c.08-.42.16-.96.16-1.41,0-1.14-.43-1.88-1.63-1.88-1.35,0-2.95,1.55-3.39,3.97l-1.03,5.54h-1.8l1.21-6.34c.09-.48.15-.9.15-1.32,0-.91-.25-1.85-1.62-1.85s-3.04,1.79-3.45,4.08l-1,5.43h-1.81Z'
				className='shape'
			/>
			<path
				d='M753.77,632.73c0,3.34-2.37,6.8-6,6.8-2.71,0-4.22-2.01-4.22-4.44,0-3.57,2.48-6.86,5.99-6.86,2.91,0,4.23,2.2,4.23,4.49ZM745.46,635.02c0,1.76.98,3.04,2.56,3.04,2.18,0,3.83-2.83,3.83-5.34,0-1.26-.58-3.02-2.52-3.02-2.33,0-3.88,2.84-3.88,5.32Z'
				className='shape'
			/>
			<path
				d='M756.85,639.29l1.32-6.96c.27-1.41.43-2.84.55-3.84h1.63c-.09.75-.18,1.51-.3,2.35h.06c.71-1.48,1.86-2.59,3.31-2.59.17,0,.39.01.53.04l-.36,1.83c-.13-.03-.29-.04-.5-.04-1.6,0-3.03,1.94-3.5,4.45l-.89,4.77h-1.85Z'
				className='shape'
			/>
			<path
				d='M773.4,638.67c-.82.46-2.12.85-3.57.85-2.87,0-4.11-1.96-4.11-4.35,0-3.25,2.42-6.94,5.89-6.94,2.06,0,3.17,1.23,3.17,2.77,0,2.84-3.2,3.58-7.19,3.51-.09.47-.03,1.48.22,2.06.43.97,1.29,1.45,2.4,1.45,1.28,0,2.25-.38,2.91-.74l.27,1.38ZM771.35,629.68c-1.76,0-3.1,1.72-3.55,3.41,2.91.03,5.19-.35,5.19-2.04,0-.89-.68-1.38-1.64-1.38Z'
				className='shape'
			/>
			<polygon
				points='677.94 636.55 678.11 643.5 685.41 643.5 678.22 647.79 678.39 654.74 673.77 650.45 666.57 654.74 670.91 647.79 666.29 643.5 673.6 643.5 677.94 636.55'
				className='shape'
			/>
			<rect
				x='670.04'
				y='521.27'
				width='60.55'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M669.43,560.79l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M703.92,557.61c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.69-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<rect
				x='544.69'
				y='329.07'
				width='72.08'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M544.08,368.59l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M577.94,371.67l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
		</svg>
	);
};

OklahomaMap.propTypes = {
	onZoneClick: PropTypes.func.isRequired,
	selectedZone: PropTypes.string,
};

export default OklahomaMap;
